import React from "react";
import PropTypes from "prop-types";
import {
  Box,
  styled,
  Tooltip,
  tooltipClasses,
  TooltipProps,
  Typography,
} from "@mui/material";
import { useAblyConnectionState } from "Hooks/useAblyConnectionState";
import { ABLY_CONNECTION_STATUS } from "Components/Constants/AblyConnectionStatus";
import { Info } from "@mui/icons-material";

const BootstrapTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} arrow placement="top" classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: theme.palette.common.black,
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.common.black,
  },
}));

export default function Title(props: any) {
  // console.log(props?.showConnection);

  const connectionState = useAblyConnectionState();
  const statusColor =
    connectionState == ABLY_CONNECTION_STATUS.CONNECTED ? "#126550" : "#cc0000";

  return (
    <div
      className="title-card"
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
      }}
    >
      <Typography component="p" variant="subtitle1">
        {props.children}
      </Typography>

      {props?.showConnection && (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 0.5,
            backgroundColor: "#c9c9c9",
            px: 1,
            py: 0.2,
            borderRadius: 10,
          }}
        >
          <Box
            sx={{ p: 0.5, backgroundColor: statusColor, borderRadius: "50%" }}
          ></Box>
          <Typography
            variant="caption"
            sx={{ textTransform: "capitalize", fontWeight: 600 }}
          >
            {connectionState}
          </Typography>
        </Box>
      )}

      {props?.showInfo && (
        <BootstrapTooltip
          sx={{ letterSpacing: 0.6, fontSize: 12 }}
          title={props?.infoMsg ?? ""}
        >
          <Info />
        </BootstrapTooltip>
      )}
    </div>
  );
}

Title.propTypes = {
  children: PropTypes.node,
};
